module.exports = __webpack_public_path__ + "media/src/images/icons/triangle_up-39fbd3c17db76674d8b1f288a26ecce8.svg";